module.exports = __webpack_public_path__ + "static/media/diktat-21.a0198cf4.mp3";